$(function ($) {
  $(document).ready(function() {
    if($("#mega-menu-usa").length) {
      if($(".navigation-horizontal__list").find('.active').length) {
        //localStorage.setItem('breadcrumb_data','');
        var get_breadcrumb = $(".navigation-horizontal__list").find('.active').html();
        var get_closest_parent = $(".navigation-horizontal__list").find('.active').closest('.navigation-horizontal__list-item.navigation-horizontal__list-item--expandable').find('a.navigation-horizontal__list-link').text();
        var get_closest_parent_link = $(".navigation-horizontal__list").find('.active').closest('.navigation-horizontal__list-item.navigation-horizontal__list-item--expandable').find('a.navigation-horizontal__list-link').attr('href');
        var get_only_sidebar_link = `<a href="${get_closest_parent_link}">${get_closest_parent}</a>`;
        //localStorage.setItem('breadcrumb_data','');
        localStorage.setItem('breadcrumb_data', get_only_sidebar_link);
        if($(".width-subcollection-sidebar").length) {
          localStorage.setItem('breadcrumb_data','');
          var get_sidebar = $(".width-subcollection-sidebar").find('.menuName').html();
          var get_only_sidebar_link = $(".width-subcollection-sidebar").find('.menuName a').html();
          localStorage.setItem('breadcrumb_data', get_only_sidebar_link);
        }
        if (localStorage.getItem("breadcrumb_data") !== null) {
          get_only_sidebar_link = localStorage.getItem("breadcrumb_data");
        }
        var get_fin_link = '';
        if($(".navigation-horizontal__list").find('.active').attr('href') !== undefined) {
          get_fin_link = $(".navigation-horizontal__list").find('.active').attr('href');
        }
        var get_temp_brd = '';
        if($('.temp-brd').length) {
          get_temp_brd = $('.temp-brd').html();
        }
        $('.col-heading-block .breadcrumb').find('.temp-brd').remove();
        var get_temp_breadcrumb = $('.col-heading-block .breadcrumb').html();
        var add_templating = `<h2 class="heading-3">${get_only_sidebar_link}</h2>
<span aria-hidden="true">&rsaquo;</span>
<h2 class="heading-3">${get_temp_brd}</h2>
`;
        //console.log(add_templating);
        $('.col-heading-block .breadcrumb').append(add_templating);
      }
    }
  });
});